import React from 'react';
import { Button, Text } from '@react-email/components';
import { palette } from '../../theme/palette';

// These are content-only pieces (no outer Section/table wrapper) — the preview page
// wraps them in the same padded white "body-section" card used by JobAdBody/WeeklyBlogBody,
// via the render-then-string-splice approach already used in EmailTemplatePreview.js.
// Bodies with an optional field (RequestAccess/AccessRejected `Message`) are split into
// pieces so the page can splice a `{{if .Message}}...{{end}}` block between them,
// the same way JobAdBodyHeader/JobAdBodyFooter bracket the `{{range .JobAds}}` loop.

const heading = {
  fontFamily: "'Montserrat', sans-serif",
  fontSize: '25px',
  fontWeight: '600',
  color: '#000',
  margin: '0 0 16px 0',
};

const paragraph = {
  fontFamily: "'Montserrat', sans-serif",
  fontSize: '14px',
  fontWeight: '400',
  lineHeight: '22px',
  color: palette.text.primary,
  margin: '0 0 16px 0',
};

const cta = {
  backgroundColor: '#13373F',
  color: '#FFF',
  fontFamily: "'Montserrat', sans-serif",
  fontSize: '14px',
  fontWeight: '500',
  lineHeight: '24px',
  borderRadius: '24px',
  padding: '12px 24px',
};

export const InviteEmailBody = ({ inviteeName, companyName, url }) => (
  <>
    <Text style={heading}>You're invited to join {companyName}</Text>
    <Text style={paragraph}>Hi {inviteeName},</Text>
    <Text style={paragraph}>
      You've been invited to join {companyName} on Delegon. Accept the invitation below to get started.
    </Text>
    <Button style={cta} href={url}>Accept Invitation</Button>
  </>
);

export const RequestAccessEmailIntro = ({ adminName, requesterName, companyName }) => (
  <>
    <Text style={heading}>Access requested for {companyName}</Text>
    <Text style={paragraph}>Hi {adminName},</Text>
    <Text style={paragraph}>
      {requesterName} has requested access to {companyName} on Delegon.
    </Text>
  </>
);

export const RequestAccessEmailCTA = ({ url }) => (
  <Button style={cta} href={url}>Review Request</Button>
);

export const AccessAcceptedEmailBody = ({ userName, companyName, url }) => (
  <>
    <Text style={heading}>Your access request was accepted</Text>
    <Text style={paragraph}>Hi {userName},</Text>
    <Text style={paragraph}>
      Your request to join {companyName} on Delegon has been accepted. You can now log in and get started.
    </Text>
    <Button style={cta} href={url}>Go to Delegon</Button>
  </>
);

export const AccessRejectedEmailIntro = ({ userName, companyName }) => (
  <>
    <Text style={heading}>Your access request was declined</Text>
    <Text style={paragraph}>Hi {userName},</Text>
    <Text style={paragraph}>
      Your request to join {companyName} on Delegon has been declined.
    </Text>
  </>
);

// Shared piece for the optional "Message"/"Reason" paragraph — rendered separately
// so the page can wrap it with `{{if .Message}}...{{end}}`.
export const OptionalMessageParagraph = ({ message }) => (
  <Text style={paragraph}>{message}</Text>
);

export const BuyerSignUpEmailBody = ({ userName, userEmail, phoneNumber }) => (
  <>
    <Text style={heading}>New buyer sign-up</Text>
    <Text style={paragraph}>Name: {userName}</Text>
    <Text style={paragraph}>Email: {userEmail}</Text>
    <Text style={paragraph}>Phone: {phoneNumber}</Text>
  </>
);

export const ContactUsEmailBody = ({ name, email, phone, message }) => (
  <>
    <Text style={heading}>New contact form message</Text>
    <Text style={paragraph}>Name: {name}</Text>
    <Text style={paragraph}>Email: {email}</Text>
    <Text style={paragraph}>Phone: {phone}</Text>
    <Text style={paragraph}>Message: {message}</Text>
  </>
);

export const NotificationEmailBody = ({ recipientName, title, message, url }) => (
  <>
    <Text style={heading}>{title}</Text>
    <Text style={paragraph}>Hi {recipientName},</Text>
    <Text style={paragraph}>{message}</Text>
    <Button style={cta} href={url}>Open in Delegon</Button>
  </>
);
